export default __webpack_public_path__ + "static/media/342.6708b2ab.jpg";